import { formatAmount } from '@staff/shared'

import type { Debt } from '@/views/debt/debt.types'

type Loan = Debt['loans'][number]

/**
 * A pending amortization change: the API returns nextAmortizationPerPeriod once a new amount is
 * booked, and it takes effect on the next monthly invoice. Returns null while nothing is pending
 * (the API falls back to the current amount, so an equal value means "no change booked").
 */
export const pendingAmortizationPerPeriod = (loan: Loan): number | null => {
  const { amortizationPerPeriod, nextAmortizationPerPeriod } = loan.loanTerms

  if (nextAmortizationPerPeriod === null || nextAmortizationPerPeriod === amortizationPerPeriod) {
    return null
  }

  return nextAmortizationPerPeriod
}

/** The amount that applies from the next monthly invoice: the pending change, else the current amount. */
export const effectiveAmortizationPerPeriod = (loan: Loan): number =>
  pendingAmortizationPerPeriod(loan) ?? loan.loanTerms.amortizationPerPeriod ?? 0

export const pendingAmortizationNote = (amount: number) => `${formatAmount(amount)} kr/mån fr.o.m. nästa månadsavi`
